<template>
  <div class="list-layout-wrapper">
    <div class="p-3">
      <h2>{{ $t('_web_tournament_players_draw-mode', 'Draw mode') }}</h2>

      <div>
        <HeraFormTextInput
          :placeholder="$t('_web_tournament_players_search', 'Search')"
          @change="onSearch"
        />

        <template v-for="(filter, index) in allPlayersFilters">
          <div :key="index" class="mb-1">
            <HeraFormDropdown
              :key="filter.name"
              v-model="filters[filter.name]"
              :list="getFiltersOptions(filter)"
              :empty-option="true"
              :could-be-empty="true"
              empty-text="All"
              :label="filter.label + ':'"
              :disabled="!getFiltersOptions(filter).length && !players.length"
              @input="onFilterChange"
            >
              <template slot="item" slot-scope="options">
                <span>
                  {{ options.item }}
                </span>
              </template>
            </HeraFormDropdown>
          </div>
        </template>
      </div>
    </div>

    <div class="pl-3 ">
      <div class="mb-2">
        <span
          >{{
            $t('_web_tournament_players_participants', 'Participants')
          }}:</span
        >
        <span>{{ list.length }}</span>
      </div>
      <div class="custom-scrollbar">
        <draggable v-model="list" @start="drag = true" @end="drag = false">
          <div v-for="(player, index) in list" :key="index" class="py-2">
            <Avatar
              :size="36"
              :type="player.type"
              :img-url="player.avatar"
              class="mr-2"
            />
            <span>{{ player.name }}</span>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import HeraFormTextInput from '@/components/atoms/form/HeraFormTextInput';
import HeraFormDropdown from '@/components/molecules/form/HeraFormDropdown';
import Avatar from '@/components/images/Avatar';
import draggable from 'vuedraggable';

export default {
  name: 'UserList',
  components: {
    draggable,
    HeraFormTextInput,
    Avatar,
    HeraFormDropdown,
  },

  data: () => ({
    filters: {},
    players: [],
    list: [
      { name: 'Username' },
      { name: 'Username2' },
      { name: 'Username3' },
      { name: 'Username4' },
      { name: 'Username5' },
      { name: 'Username6' },
      { name: 'Username7' },
      { name: 'Username8' },
      { name: 'Username9' },
      { name: 'Username10' },
      { name: 'Username12' },
      { name: 'Username13' },
      { name: 'Username14' },
      { name: 'Username15' },
      { name: 'Username16' },
    ],
  }),

  computed: {
    allPlayersFilters() {
      return [
        {
          name: 'attribute',
          label: 'Attribute',
          options: this.distinctPlayersAttributes,
        },
        {
          name: 'status',
          label: 'Status',
          options: this.distinctPlayersStatuses,
        },
      ];
    },

    distinctPlayersAttributes() {
      return [];
    },

    distinctPlayersStatuses() {
      return ['Pickup', 'Seed', 'Blacklist'];
    },
  },

  methods: {
    onSearch() {},

    onFilterChange() {
      this.tournaments = [];
      this.next_page_token = undefined;
    },

    getFiltersOptions(filter) {
      return [...filter.options];
    },
  },
};
</script>

<style lang="scss" scoped>
.list-layout-wrapper {
  background: $ph-card;

  .dropdown {
    display: inline-block !important;

    button {
      background-color: $ph-input-bg;
    }
  }
}

.custom-scrollbar {
  max-height: 540px;
}
</style>
